// School association validation -- iteration 072
import { z } from "zod";

export const createSchoolAssociationSchema = z.object({
  school_id: z.string().min(1),
  school_email: z.string().email().optional(),
});

export const addSchoolEmailSchema = z.object({
  email: z.string().email(),
});

export type CreateSchoolAssociationInput = z.infer<typeof createSchoolAssociationSchema>;
export type AddSchoolEmailInput = z.infer<typeof addSchoolEmailSchema>;
